import { useState, useEffect, Fragment } from 'react'
import Modal from 'react-bootstrap/Modal'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'

import { AdjustColumns, Input, Button } from '../../../styles'
import Colors from '../../../../../constants/Colors'
import { getOrdersByStatus } from '../../../Services/serviceAdmin'
import {
  approveBadSlip,
  rejectBadSlip,
  readQRCode,
  readQRCodeAgain,
  getRemainingAmount,
  messagesToCustomer,
  getAllSlipInOrder,
} from '../../../Services/servicePayment'
import { alertCompleted, alertError, alertBeforeHandle } from '../../../utils'
import {
  BAD_SLIP_SCAN_ERROR_MSG,
  SLIP_RECHECK_ERROR_MSG,
  DEFAULT_ERROR_MSG,
  SLIP_APPROVE_ERROR_MSG,
} from '../../../../../constants/order/error/const'

const Transaction = ({ order, slip, setSlips, setOrders, setRemainingAmount, fetchOrdersByStatus }) => {
  const [inputRefNoSlip, setInputRefNoSlip] = useState('')
  const [isShow, setIsShow] = useState(false)
  const [amount, setAmount] = useState('')
  const [inputScan, setInputScan] = useState('')
  const [isDisabled, setIsDisabled] = useState(true)
  const dispatch = useDispatch()

  useEffect(() => {
    setIsDisabled(!inputRefNoSlip || !amount)
  }, [inputRefNoSlip, amount])

  useEffect(() => {
    setAmount('')
    setInputRefNoSlip('')
  }, [order])

  const approveSlip = async () => {
    dispatch({ type: 'loading_show' })
    const body = {
      userId: order?.userInfo?.userId,
      refNo: inputRefNoSlip,
      transactionId: slip?.transaction[0]?.id,
      amount: parseInt(amount),
      orderRefNo: order?.orderId,
      category: 'COUPON',
    }

    const response = await approveBadSlip(body)

    if (response?.success) {
      dispatch({ type: 'loading_hide' })
      await alertCompleted()
      let remainAmount = undefined
      const allSlip = await getAllSlipInOrder(order?.orderId)

      if (allSlip?.length > 0) {
        const remaining = await getRemainingAmount(allSlip[0]?.id)
        remainAmount = remaining?.remainingAmount
        if (remainAmount <= 0) {
          await fetchOrdersByStatus('CONFIRMED')
        } else {
          setSlips(allSlip)
          setRemainingAmount(remainAmount)
        }
      }
    } else if (response.code === 1002) {
      dispatch({ type: 'loading_hide' })
      alertError(response.msg)
    } else {
      dispatch({ type: 'loading_hide' })
      alertError(SLIP_APPROVE_ERROR_MSG[response.code] || DEFAULT_ERROR_MSG)
    }
    dispatch({ type: 'loading_hide' })
  }

  const rejectSlip = async () => {
    dispatch({ type: 'loading_show' })
    const body = { transactionId: slip?.transaction[0]?.id }
    const response = await rejectBadSlip(body)

    if (response.success) {
      dispatch({ type: 'loading_hide' })
      await alertCompleted()
      const allSlip = await getAllSlipInOrder(order?.orderId)
      setSlips(allSlip)
    } else {
      dispatch({ type: 'loading_hide' })
      alertError(response.msg)
    }
    dispatch({ type: 'loading_hide' })
  }

  const readSlip = async () => {
    dispatch({ type: 'loading_show' })
    const body = {
      slipId: slip?.id,
      category: 'COUPON',
      qrcode: inputScan,
      transactionId: slip?.transaction[0]?.id,
      userId: order?.userInfo?.userId,
    }
    const response = await readQRCode(slip?.id, body)

    if (response.success) {
      dispatch({ type: 'loading_hide' })
      await alertCompleted()
      const res = await getOrdersByStatus(order?.status)
      if (res?.length > 0) {
        const notIssue = res.filter((v) => !v.isIssue)
        setOrders(notIssue)
      }
    } else if (response.code === 1002) {
      dispatch({ type: 'loading_hide' })
      alertError(response.msg)
    } else {
      dispatch({ type: 'loading_hide' })
      alertError(BAD_SLIP_SCAN_ERROR_MSG[response.code] || DEFAULT_ERROR_MSG)
    }
    dispatch({ type: 'loading_hide' })
  }

  const readQRCodeAgainModal = () => {
    return (
      <Modal show={isShow} onHide={() => setIsShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>สแกน</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-warning text-center">
          <img src={slip?.imageUrl} width="80%" height="80%" alt="slipImage" />
          <Input type="text" placeholder="" className="mb-1 mt-3" onChange={(e) => setInputScan(e.target.value)} />
        </Modal.Body>
        <Modal.Footer>
          <Button bgColor={Colors.BLUE} onClick={readSlip}>
            บันทึก
          </Button>
          <Button bgColor={Colors.LIGHT_RED} onClick={() => setIsShow(false)}>
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  const readSlipAgain = async () => {
    dispatch({ type: 'loading_show' })
    const body = {
      slipId: slip?.id,
      category: 'COUPON',
      transactionId: slip?.transaction[0]?.id,
      userId: order?.userInfo?.userId,
    }
    const response = await readQRCodeAgain(slip?.id, body)
    if (response.success) {
      dispatch({ type: 'loading_hide' })
      await alertCompleted()
    } else {
      dispatch({ type: 'loading_hide' })
      alertError(SLIP_RECHECK_ERROR_MSG[response.code] || DEFAULT_ERROR_MSG)
    }
    dispatch({ type: 'loading_hide' })
  }

  const sendMessagesToCustomer = async (templateName) => {
    try {
      dispatch({ type: 'loading_show' })
      const { remainingAmount } = await getRemainingAmount(slip?.id)
      const body = {
        category: 'COUPON',
        refNo: order?.orderId,
        remingAmount: remainingAmount,
        templateName,
        transactionId: slip?.transaction[0]?.id,
        userId: order?.userInfo?.userId,
      }
      const response = await messagesToCustomer(body)
      if (response.success) {
        dispatch({ type: 'loading_hide' })
        await alertCompleted()
      } else {
        dispatch({ type: 'loading_hide' })
        alertError(response.msg)
      }
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      console.error('sendMessagesToCustomer error ---> ', error)
      dispatch({ type: 'loading_hide' })
      alertError()
    }
  }

  const renderRejected = () => {
    return (
      <div className="mt-1">
        <AnnouncementButton
          bgColor={Colors.OCEAN_BLUE}
          onClick={() => alertBeforeHandle('แจ้งเตือนสลิปไม่ถูกต้อง', () => sendMessagesToCustomer('SLIP-INCORRECT'))}
        >
          แจ้งเตือนลูกค้าว่าสลิปที่แนบมาไม่ถูกต้อง
        </AnnouncementButton>
        <AnnouncementButton
          bgColor={Colors.ORANGE_GRADIENT}
          onClick={() => alertBeforeHandle('แจ้งเตือนยอดค้างชำระ', () => sendMessagesToCustomer('INCOMPLETE-PAYMENT'))}
        >
          แจ้งเตือนลูกค้ายอดค้างชำระล่าสุด
        </AnnouncementButton>
        <AnnouncementButton
          bgColor={Colors.SKY}
          onClick={() => alertBeforeHandle('อ่านบาร์โค้ดอีกครั้ง', readSlipAgain)}
        >
          อ่านบาร์โค้ด QR สลิปใหม่
        </AnnouncementButton>
      </div>
    )
  }

  const renderBadSlip = () => {
    if (order?.status !== 'CONFIRMED') return false
    return (
      <>
        <div>รหัสอ้างอิง:</div>
        <Input
          type="text"
          placeholder=""
          value={inputRefNoSlip}
          className="mb-1"
          onChange={(e) => {
            if (!e.target.value) setInputRefNoSlip('')
            if (/^[0-9a-z]+$/i.test(e.target.value)) setInputRefNoSlip(e.target.value)
          }}
        />
        <div>จำนวนเงิน:</div>
        <Input
          type="text"
          placeholder=""
          value={amount}
          className="mb-1"
          onChange={(e) => {
            if (!e.target.value) setAmount('')
            if (/^[0-9]+(\.{1}[0-9]{0,2})?$/.test(e.target.value)) setAmount(e.target.value)
          }}
        />
        {isDisabled ? (
          <ButtonDisabled className="mb-1" bgColor={Colors.GREEN}>
            อนุมัติสลิป
          </ButtonDisabled>
        ) : (
          <Button className="mb-1" bgColor={Colors.GREEN} onClick={() => alertBeforeHandle('อนุมัติสลิป', approveSlip)}>
            อนุมัติสลิป
          </Button>
        )}
        <Button bgColor={Colors.LIGHT_RED} onClick={() => alertBeforeHandle('ปฏิเสธสลิป', rejectSlip)} className="mb-1">
          ปฏิเสธสลิป
        </Button>
        <Button bgColor={Colors.BLUE} onClick={() => setIsShow(true)}>
          อ่านบาร์โค้ด
        </Button>
        {readQRCodeAgainModal()}
      </>
    )
  }

  const rederOnProcess = () => {
    return (
      <AdjustColumns>
        <ImageBox>
          <img src={slip?.imageUrl} width="100%" height="100%" alt="slipImage" />
        </ImageBox>
        <BoxFlex>
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <h3>ระบบกำลังประมวลผล...</h3>
          </div>
        </BoxFlex>
      </AdjustColumns>
    )
  }

  const renderHistory = () => {
    if (!slip) return false

    const transaction = slip?.transaction[0].actionTransaction

    if (transaction.length === 0) return null
    return (
      <div>
        <Title>ประวัติการแจ้งเตือน</Title>
        {transaction?.map((v, i) => {
          return (
            <div key={i}>
              <div>[ {v.from} ]</div> : {v.action}
            </div>
          )
        })}
      </div>
    )
  }

  const renderAdminSolvedDetail = () => {
    if (!slip || slip.transaction?.length === 0) return false

    const adminSolved = slip?.transaction[0].solvedBy

    if (!adminSolved) return null

    return (
      <div>
        <Title>ข้อมูลรายละเอียดการจัดสลิป Slip โดย Admin</Title>
        <p>
          <b>ชื่อผู้ตรวจสอบ</b>: {adminSolved.userName}
        </p>
        <p>
          <b>ผลการตรวจสอบ</b>: {adminSolved.detail}
        </p>
        <p>
          <b>ตรวจสอบเมื่อเวลา</b>: {new Date(adminSolved.createdAt).toLocaleString('TH-th')} น.
        </p>
      </div>
    )
  }

  const renderTransaction = () => {
    const { status, amount, remark, createdAt } = slip?.transaction[0]
    return (
      <>
        <AdjustColumns>
          <ImageBox>
            <img src={slip?.imageUrl} width="100%" height="100%" alt="slipImage" />
          </ImageBox>
          <BoxFlex>
            <AdjustColumns>
              <b>สถานะ</b>
              <div>{status}</div>
            </AdjustColumns>
            <AdjustColumns>
              <b>จำนวนเงินที่ระบบอ่านได้</b>
              <div>{amount} บาท</div>
            </AdjustColumns>
            <AdjustColumns>
              <b>รายละเอียด</b>
              <div>{remark}</div>
            </AdjustColumns>
            <AdjustColumns>
              <b>อัปโหลดเมื่อเวลา</b>
              <div>{new Date(slip?.createdAt).toLocaleString('TH-th')} น.</div>
            </AdjustColumns>
            <AdjustColumns>
              <b>ตรวจสอบเมื่อเวลา</b>
              <div>
                {new Date(createdAt).toLocaleString('TH-th')}
                น.
              </div>
            </AdjustColumns>
            <AdjustColumns>{renderHistory()}</AdjustColumns>
            <AdjustColumns>{renderAdminSolvedDetail()}</AdjustColumns>
          </BoxFlex>
        </AdjustColumns>

        {status === 'REJECTED' && renderRejected()}
        {status === 'BAD_SLIP' && renderBadSlip()}
      </>
    )
  }
  if (slip.length === 0) return false

  return <>{slip?.transaction.length > 0 ? renderTransaction() : rederOnProcess()}</>
}

export default Transaction

const AnnouncementButton = styled.div`
  padding: 20px 0;
  margin-bottom: 10px;
  flex: 1;
  text-align: center;
  &:hover {
    cursor: pointer;
    box-shadow:
      rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,
      rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
  }
  box-shadow: rgba(0, 0, 0, 0.8) 1.95px 1.95px 2.6px;
  color: ${Colors.WHITE};
  background: ${({ bgColor }) => bgColor};
`
const ButtonDisabled = styled.div`
  padding: 20px 0;
  flex: 1;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.8) 1.95px 1.95px 2.6px;
  opacity: 0.7;
  color: ${Colors.WHITE};
  background-color: ${({ bgColor }) => bgColor};
`
const BoxFlex = styled.div`
  flex: 1;
  h4 {
    margin: 0;
  }
`
const ImageBox = styled.div`
  width: 100%;
  height: 100%;
  max-width: 400px;
`
const Title = styled.h4``
